module.exports = __webpack_public_path__ + "static/media/21.5ecb64fd.jpg";